import axios from 'axios';

// Determine API base URL
// In production with a custom domain, always use relative /api to avoid CORS issues
let API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// If the configured backend URL is a different origin than where the app is running,
// use relative /api instead (the ingress/proxy will route it correctly)
if (typeof window !== 'undefined' && API_URL.startsWith('http')) {
  try {
    const backendOrigin = new URL(API_URL).origin;
    const currentOrigin = window.location.origin;
    if (backendOrigin !== currentOrigin && !currentOrigin.includes('localhost')) {
      API_URL = currentOrigin;
    }
  } catch {}
}

if (!API_URL.endsWith('/api')) {
  API_URL = `${API_URL}/api`;
}

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Respect an explicitly-provided Authorization header (e.g. the MFA
    // challenge token used during login) — never overwrite it with the stored
    // application token.
    const headers = config.headers || {};
    const explicitAuth = headers.Authorization
      || (typeof headers.get === 'function' && headers.get('Authorization'));
    if (!explicitAuth) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect for vault/password verification endpoints — 401 means wrong password, not expired session
      const url = error.config?.url || '';
      if (url.includes('/vault/verify') || url.includes('/verify-password') || url.includes('/credentials/') && url.includes('/reveal')) {
        return Promise.reject(error);
      }
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
